const ShowMoreText = class ShowMoreText {

    constructor(config) {
       this.jsMemberTextTrigger = config.jsMemberTextTrigger,
       this.jsTeamMemberSummery = config.jsTeamMemberSummery,
       this.jsTeamMemberDetails = config.jsTeamMemberDetails
    }



    init() {
        this.detailsTrigger();
    }

    detailsTrigger(){
        const trigger = this.jsMemberTextTrigger,
              summery = this.jsTeamMemberSummery,
              details = this.jsTeamMemberDetails;

        let dataStatus,
            $self;

        trigger.on('click', function (e) {
            e.preventDefault();
            $self = $(this),
                dataStatus = $self.attr('data-status');
            if(dataStatus == 'off'){
                $self.attr('data-status', 'on');
                $self.parent().find(details).show();
                $self.parent().find(summery).hide();
                $self.html($self.data('hide-text'));
            }
            else{
                $self.attr('data-status', 'off');
                $self.parent().find(summery).show();
                $self.parent().find(details).hide();
                $self.html($self.data('show-text'));
            }
        });
    }
};


export {ShowMoreText}


// WEBPACK FOOTER //
// ./static/js/components/ShowMoreText.js